import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { IMutliLanguageText } from '@app-root-interfaces';

@Pipe({
    name: 'titleLanguage',
    standalone: false
})
export class TitleLanguagePipe implements PipeTransform {
    private translateService = inject(TranslateService);

    transform(titles: IMutliLanguageText[]): Observable<string> {
        if (!titles || titles.length === 0) {
            return of('');
        }
        return this.translateService.onLangChange.pipe(
            startWith(this.translateService.currentLang() ?? 'en'),
            map((event) => {
                const language = typeof event !== 'string' ? event.lang : event;

                // Titel in der richtigen Sprache gefunden
                const matchingTitles = titles.filter((title) => title.language.toLowerCase() === language);
                if (matchingTitles.length > 0) {
                    return matchingTitles[0].text;
                }

                // Titel in englisch finden
                const englishTitle = titles.filter((title) => title.language.toLowerCase() === 'en');
                if (englishTitle.length > 0) {
                    return englishTitle[0].text;
                }

                return titles[0].text;
            })
        );
    }
}
